<template>
  <v-data-table
    :headers="headers"
    :items="inLineQualityChecks"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="InLineQualityCheck-button-new"
          @click="$router.push({
            name: 'in-line-quality-check-EditInLineQualityCheck'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'in-line-quality-check-EditInLineQualityCheck',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListInLineQualityCheck',
  module: 'InLineQualityCheck',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('inLineQualityChecks', ['inLineQualityChecks']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('deliveryDate'),
          value: 'deliveryDate',
        },
        {
          text: this.$$t('farm'),
          value: 'farm',
        },
        {
          text: this.$$t('sizeRange'),
          value: 'sizeRange',
        },
        {
          text: this.$$t('shuckingDamagePoorTechnique'),
          value: 'shuckingDamagePoorTechnique',
        },
        {
          text: this.$$t('shuckingDamagePoorProduct'),
          value: 'shuckingDamagePoorProduct',
        },
        {
          text: this.$$t('shuckingGutsRemovedProperly'),
          value: 'shuckingGutsRemovedProperly',
        },
        {
          text: this.$$t('generalQuality'),
          value: 'generalQuality',
        },
        {
          text: this.$$t('shuckingComments'),
          value: 'shuckingComments',
        },
        {
          text: this.$$t('beakCuttingDamagePoorTechnique'),
          value: 'beakCuttingDamagePoorTechnique',
        },
        {
          text: this.$$t('beakCuttingGutsRemovedProperly'),
          value: 'beakCuttingGutsRemovedProperly',
        },
        {
          text: this.$$t('beakCuttingOtherComments'),
          value: 'beakCuttingOtherComments',
        },
        {
          text: this.$$t('beakCuttingComments'),
          value: 'beakCuttingComments',
        },
        {
          text: this.$$t('scrubbingAnimalsClean'),
          value: 'scrubbingAnimalsClean',
        },
        {
          text: this.$$t('scrubbingGutsRemovedProperly'),
          value: 'scrubbingGutsRemovedProperly',
        },
        {
          text: this.$$t('scrubbingForeignMatter'),
          value: 'scrubbingForeignMatter',
        },
        {
          text: this.$$t('scrubbingDamagedAnimals'),
          value: 'scrubbingDamagedAnimals',
        },
        {
          text: this.$$t('scrubbingComments'),
          value: 'scrubbingComments',
        },
        {
          text: this.$$t('preBlanchingMeatTemp'),
          value: 'preBlanchingMeatTemp',
        },
        {
          text: this.$$t('blanchingHotWaterTemp'),
          value: 'blanchingHotWaterTemp',
        },
        {
          text: this.$$t('blanchingColdWaterTemp'),
          value: 'blanchingColdWaterTemp',
        },
        {
          text: this.$$t('blanchingComments'),
          value: 'blanchingComments',
        },
        {
          text: this.$$t('preCanningAnimalsClean'),
          value: 'preCanningAnimalsClean',
        },
        {
          text: this.$$t('preCanningDamagedAnimals'),
          value: 'preCanningDamagedAnimals',
        },
        {
          text: this.$$t('preCanningCracking'),
          value: 'preCanningCracking',
        },
        {
          text: this.$$t('preCanningComments'),
          value: 'preCanningComments',
        },
        {
          text: this.$$t('packedCanScratched'),
          value: 'packedCanScratched',
        },
        {
          text: this.$$t('packedCorrect'),
          value: 'packedCorrect',
        },
        {
          text: this.$$t('packedDamagedAnimals'),
          value: 'packedDamagedAnimals',
        },
        {
          text: this.$$t('packedIngoWithinLimits'),
          value: 'packedIngoWithinLimits',
        },
        {
          text: this.$$t('packedCorrectPieceCount'),
          value: 'packedCorrectPieceCount',
        },
        {
          text: this.$$t('packedComments'),
          value: 'packedComments',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_inLineQualityChecks();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('inLineQualityChecks', ['LOAD_inLineQualityChecks', 'DELETE_inLineQualityCheck']),
    /** Delete InLineQualityCheck from the collection
     */
    async remove(InLineQualityCheck) {
      this.isLoading = true;
      await this.DELETE_InLineQualityCheck(InLineQualityCheck);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# InLineQualityCheck example

'''js
<InLineQualityCheck />
'''
</docs>
